export interface HorizontalScrollInput {
  patternLeft: number;
  patternWidth: number;
  containerWidth: number;
  canvasWidth: number;
  overflowMargin?: number;
}

/**
 * Calculates the desired scrollLeft value to keep the pattern either centered
 * (when it fits within the viewport) or aligned close to the left edge when it
 * overflows. The result is always clamped to the scrollable range.
 */
export function computeHorizontalScrollTarget({
  patternLeft,
  patternWidth,
  containerWidth,
  canvasWidth,
  overflowMargin = 16,
}: HorizontalScrollInput): number {
  if (containerWidth <= 0 || canvasWidth <= 0) {
    return 0;
  }

  const patternFits = patternWidth <= containerWidth;

  let desiredScroll = patternFits
    ? patternLeft + patternWidth / 2 - containerWidth / 2
    : patternLeft - overflowMargin;

  const maxScrollLeft = Math.max(0, canvasWidth - containerWidth);

  if (!isFinite(desiredScroll)) {
    desiredScroll = 0;
  }

  return Math.max(0, Math.min(desiredScroll, maxScrollLeft));
}

